// extracted by mini-css-extract-plugin
export default {"error-image":"Error_error-image__kwn5m","error-text":"Error_error-text__s-aIZ","eel":"Error_eel__UliBM Text_eel__WxNj+"};